export const ConquestPlanningHowItWorks: React.FC = () => {
  return (
    <div>
      <ul>
        <li>Link financial plans to Zocks contacts</li>
        <li>Create new Conquest plans from meeting insights, emails, or documents</li>
        <li>Update Conquest plans with insights from meetings, emails, or documents</li>
        <li>Prepare for meetings using combined data from Zocks, Conquest, and your connected systems</li>
        <li>Get instant insights from Conquest with the Ask Anything AI Assistant</li>
        <li>Generate email replies based on Conquest planning information</li>
        <li>Fill Zocks Forms utilizing financial planning data from Conquest</li>
      </ul>
    </div>
  )
}
